export default __webpack_public_path__ + "static/media/7.497f0c87.png";